export function getFacetSetSliceInitialState(request) {
    return { request, hasBreadcrumbs: true };
}
export function getFacetSetInitialState() {
    return {};
}
